import { create } from 'zustand';
import { SEARCH_TYPE } from '../components/search/SearchTypeEnum';

export interface SearchTypeStore {
  searchType: SEARCH_TYPE;
  setSearchType: (searchType: SEARCH_TYPE) => void;
}

export const useSearchTypeStore = create<SearchTypeStore>()((set, get) => ({
  searchType: SEARCH_TYPE.MEDICINE,
  setSearchType: (searchType: SEARCH_TYPE) => {
    set((prev) => {
      return {
        ...prev,
        searchType: searchType,
      };
    });
  },
}));
